"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @deckee/app-main
 * App main integration endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jason@deckee.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafetyRecommendationCategoryIconToJSON = exports.SafetyRecommendationCategoryIconFromJSONTyped = exports.SafetyRecommendationCategoryIconFromJSON = exports.SafetyRecommendationCategoryIcon = void 0;
/**
 *
 * @export
 */
exports.SafetyRecommendationCategoryIcon = {
    Lifejacket: 'lifejacket',
    Flare: 'flare',
    Compass: 'compass',
    Killswitch: 'killswitch',
    FireExtinguisher: 'fire_extinguisher',
    Radio: 'radio',
    AnchorLine: 'anchor_line',
    BilgePumpBailer: 'bilge_pump_bailer',
    BackfireFlameArrestor: 'backfire_flame_arrestor',
    LifeBouy: 'life_bouy',
    Ventilation: 'ventilation',
    LifeRaft: 'life_raft',
    License: 'license',
    FlashLight: 'flash_light',
    VSheet: 'v_sheet',
    SignallingDevice: 'signalling_device',
    PaperCharts: 'paper_charts',
    Rope: 'rope',
    BottleOfWater: 'bottle_of_water',
    Bucket: 'bucket',
    SafetyChecklist: 'safety_checklist',
    OarOrPaddle: 'oar_or_paddle',
    FirstAidKit: 'first_aid_kit',
    Misc: 'misc'
};
function SafetyRecommendationCategoryIconFromJSON(json) {
    return SafetyRecommendationCategoryIconFromJSONTyped(json, false);
}
exports.SafetyRecommendationCategoryIconFromJSON = SafetyRecommendationCategoryIconFromJSON;
function SafetyRecommendationCategoryIconFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SafetyRecommendationCategoryIconFromJSONTyped = SafetyRecommendationCategoryIconFromJSONTyped;
function SafetyRecommendationCategoryIconToJSON(value) {
    return value;
}
exports.SafetyRecommendationCategoryIconToJSON = SafetyRecommendationCategoryIconToJSON;
